<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
  >
    <product-category-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-update>
</template>

<script>

import ProductCategoryProvider from "../../../../providers/ProductCategoryProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'

import ProductCategoryForm from "../ProductCategoryForm";


export default {
  name: "ProductCategoryUpdate",

  components: {ProductCategoryForm, CrudUpdate},

  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'delivery.productCategory.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        name: this.item.name,
        printName: this.item.printName,
        backgroundColor: this.item.backgroundColor ? this.item.backgroundColor : '',
        borderColor: this.item.borderColor ? this.item.borderColor : '',
        fontColor: this.item.fontColor ? this.item.fontColor : '',
        icon: this.item.icon,
        iconColor: this.item.iconColor ? this.item.iconColor : '',
        surcharge: this.item.surcharge,
        homeGallery: this.item.homeGallery ? this.item.homeGallery : false,
        drink: this.item.drink ? this.item.drink : false,
        dozen: this.item.dozen ? this.item.dozen : false,
        active: this.item.active ? this.item.active : false,
        minimumDeliveryQuantity: this.item.minimumDeliveryQuantity ? this.item.minimumDeliveryQuantity : 0,
        minimumTakeAwayQuantity: this.item.minimumTakeAwayQuantity ? this.item.minimumTakeAwayQuantity : 0
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true
        ProductCategoryProvider.updateProductCategory(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updateProductCategory)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }
  },
}
</script>

<style scoped>

</style>

